<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">Home</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/invoices">Manage Vendors</a>
                        </span>
                    </div>

                    <div class="stats-wrapper">
                        <div class="charts-wrapper">
                            <div class="row">
                                <div class="col-4">
                                    <div class="card">
                                        <div class="pane-header">
                                            <h5 class="py-3 px-3">
                                                Account Activation
                                            </h5>
                                        </div>
                                        <div class="card-body text-center">
                                            <div class="chart-container">
                                                <apx-chart
                                                    [series]="
                                                        accountActivationOptions.series
                                                    "
                                                    [chart]="
                                                        accountActivationOptions.chart
                                                    "
                                                    [dataLabels]="
                                                        accountActivationOptions.dataLabels
                                                    "
                                                    [legend]="
                                                        accountActivationOptions.legend
                                                    "
                                                    [labels]="
                                                        accountActivationOptions.labels
                                                    "
                                                    [colors]="
                                                        accountActivationOptions.colors
                                                    "
                                                ></apx-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="card">
                                        <div class="pane-header">
                                            <h5 class="py-3 px-3">
                                                Emails Sent
                                            </h5>
                                        </div>
                                        <div class="card-body text-center">
                                            <div class="chart-container">
                                                <apx-chart
                                                    [series]="
                                                        emailActivationOptions.series
                                                    "
                                                    [chart]="
                                                        emailActivationOptions.chart
                                                    "
                                                    [dataLabels]="
                                                        emailActivationOptions.dataLabels
                                                    "
                                                    [legend]="
                                                        emailActivationOptions.legend
                                                    "
                                                    [labels]="
                                                        emailActivationOptions.labels
                                                    "
                                                    [colors]="
                                                        emailActivationOptions.colors
                                                    "
                                                ></apx-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="card">
                                        <div class="pane-header">
                                            <h5 class="py-3 px-3">
                                                Emails Sent
                                            </h5>
                                        </div>
                                        <div class="card-body text-center">
                                            <div class="chart-container">
                                                <apx-chart
                                                    [series]="
                                                        portalAdoptionOptions.series
                                                    "
                                                    [chart]="
                                                        portalAdoptionOptions.chart
                                                    "
                                                    [colors]="
                                                        portalAdoptionOptions.colors
                                                    "
                                                    [plotOptions]="
                                                        portalAdoptionOptions.plotOptions
                                                    "
                                                ></apx-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vendor-table-list">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card buyer-analytics">
                                    <div class="card-body">
                                        <!-- <div class="pane-header mb-3">
                                            <h4 class="mt-2">
                                                View PO/GRN and Submit Invoices
                                            </h4>
                                        </div> -->

                                        <div class="search-pane">
                                            <div class="row">
                                                <div class="col-md-2">
                                                    <label
                                                        class="d-inline-flex align-items-center mb-3"
                                                    >
                                                        <select
                                                            class="form-select form-select-sm mx-1"
                                                            (change)="
                                                                onFilter($event)
                                                            "
                                                        >
                                                            <option
                                                                disabled
                                                                selected
                                                                hidden
                                                            >
                                                                Select
                                                            </option>
                                                            <option
                                                                value="vendor_code"
                                                            >
                                                                Vendor Code
                                                            </option>
                                                            <option
                                                                value="vendor_name"
                                                            >
                                                                Vendor Name
                                                            </option>
                                                        </select>
                                                    </label>
                                                </div>
                                                <div class="col-md-4">
                                                    <div
                                                        class="input-group flex-nowrap"
                                                    >
                                                        <ng-container
                                                            *ngIf="
                                                                selectedOption
                                                            "
                                                        >
                                                            <input
                                                                type="text"
                                                                class="form-control highlighted"
                                                                placeholder="Enter search value"
                                                                aria-label="search"
                                                                aria-describedby="addon-wrapping"
                                                                (keyup)="
                                                                    onSearch(
                                                                        $event
                                                                    )
                                                                "
                                                            />
                                                            <span
                                                                class="input-group-text highlighted"
                                                                id="addon-wrapping"
                                                                ><i
                                                                    class="ri-search-line"
                                                                ></i
                                                            ></span>
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="
                                                                !selectedOption
                                                            "
                                                        >
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Search..."
                                                                aria-label="search"
                                                                aria-describedby="addon-wrapping"
                                                                (keyup)="
                                                                    generalSearch(
                                                                        $event
                                                                    )
                                                                "
                                                            />
                                                            <span
                                                                class="input-group-text"
                                                                id="addon-wrapping"
                                                                ><i
                                                                    class="ri-search-line"
                                                                ></i
                                                            ></span>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="download-pane float-end d-flex align-items-center gap-3">
                                                        <i
                                                            class="ri-refresh-line"
                                                            title="Refresh"
                                                            (click)="!loading && reloadVendorTable()"
                                                            [style.opacity]="loading ? 0.45 : 1"
                                                            [style.pointer-events]="loading ? 'none' : 'auto'"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-responsive">
                                            <ng-container *ngIf="loading">
                                                <div class="text-center">
                                                    <app-loader></app-loader>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="!loading">
                                                <div
                                                    *ngIf="isEmpty"
                                                    class="text-center py-5"
                                                >
                                                    <img
                                                        src="assets/images/empty-state.png"
                                                        alt="No-data"
                                                    />
                                                    <h1 class="card-title my-2">
                                                        No Purchases Orders
                                                        Available
                                                    </h1>
                                                    <p class="card-text">
                                                        There is no available
                                                        data to show yet
                                                    </p>
                                                </div>
                                                <ng-container *ngIf="!isEmpty">
                                                    <table
                                                        aria-describedby="vendors-table"
                                                        id="demo-foo-pagination"
                                                        class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap text-center"
                                                        data-page-size="5"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    data-toggle="true"
                                                                >
                                                                    <div
                                                                        class="form-check"
                                                                    >
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            [checked]="
                                                                                isAllCheck()
                                                                            "
                                                                            (change)="
                                                                                checkAll(
                                                                                    $event
                                                                                )
                                                                            "
                                                                        />
                                                                    </div>
                                                                </th>
                                                                <th
                                                                    scope="col"
                                                                    [appSort]="
                                                                        vendors
                                                                    "
                                                                    data-order="desc"
                                                                    data-name="vendor_code"
                                                                    class="text-center"
                                                                >
                                                                    Vendor Code
                                                                    <span
                                                                        class="sort-indicator"
                                                                        ><i
                                                                            class="bi bi-chevron-expand"
                                                                        ></i
                                                                    ></span>
                                                                </th>

                                                                <th
                                                                    scope="col"
                                                                    [appSort]="
                                                                        vendors
                                                                    "
                                                                    data-order="desc"
                                                                    data-name="vendor_name"
                                                                    class="text-center"
                                                                >
                                                                    Vendor Name
                                                                    <span
                                                                        class="sort-indicator"
                                                                        ><i
                                                                            class="bi bi-chevron-expand"
                                                                        ></i
                                                                    ></span>
                                                                </th>

                                                                <th
                                                                    scope="col"
                                                                    [appSort]="
                                                                        vendors
                                                                    "
                                                                    data-order="desc"
                                                                    data-name="vendor_email"
                                                                >
                                                                    Vendor Email
                                                                    <span
                                                                        class="sort-indicator"
                                                                        ><i
                                                                            class="bi bi-chevron-expand"
                                                                        ></i
                                                                    ></span>
                                                                </th>

                                                                <th
                                                                    scope="col"
                                                                    [appSort]="
                                                                        vendors
                                                                    "
                                                                    data-order="desc"
                                                                    data-name="vdm_received_date"
                                                                >
                                                                    VMD Received
                                                                    Date
                                                                    <span
                                                                        class="sort-indicator"
                                                                        ><i
                                                                            class="bi bi-chevron-expand"
                                                                        ></i
                                                                    ></span>
                                                                </th>

                                                                <th
                                                                    scope="col"
                                                                    [appSort]="
                                                                        vendors
                                                                    "
                                                                    data-order="desc"
                                                                    data-name="onborading_started"
                                                                >
                                                                    Onboarding
                                                                    Started
                                                                    <span
                                                                        class="sort-indicator"
                                                                        ><i
                                                                            class="bi bi-chevron-expand"
                                                                        ></i
                                                                    ></span>
                                                                </th>

                                                                <th
                                                                    scope="col"
                                                                    [appSort]="
                                                                        vendors
                                                                    "
                                                                    data-order="desc"
                                                                    data-name="account_status"
                                                                >
                                                                    Accounts
                                                                    Status
                                                                    <span
                                                                        ><i
                                                                            class="bi bi-chevron-expand"
                                                                        ></i
                                                                    ></span>
                                                                </th>

                                                                <th
                                                                    scope="col"
                                                                    [appSort]="
                                                                        vendors
                                                                    "
                                                                    data-order="desc"
                                                                    data-name="email_delivery_status"
                                                                    class="text-center"
                                                                >
                                                                    Email
                                                                    Delivery
                                                                    Status
                                                                    <span
                                                                        class="sort-indicator"
                                                                        ><i
                                                                            class="bi bi-chevron-expand"
                                                                        ></i
                                                                    ></span>
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr
                                                                *ngFor="
                                                                    let vendor of vendors;
                                                                    let i = index
                                                                "
                                                            >
                                                                <td>
                                                                    <div
                                                                        class="form-check"
                                                                    >
                                                                        <input
                                                                            class="form-check-input"
                                                                            type="checkbox"
                                                                            [(ngModel)]="
                                                                                vendors[
                                                                                    i
                                                                                ]
                                                                                    .checked
                                                                            "
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                    >
                                                                        {{
                                                                            vendor.vendor_code
                                                                        }}
                                                                    </a>
                                                                </td>

                                                                <td>
                                                                    {{
                                                                        vendor.vendor_name
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        vendor.vendor_email
                                                                    }}
                                                                </td>

                                                                <td>
                                                                    {{
                                                                        vendor.vdm_received_date
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        vendor.onborading_started
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        *ngIf="
                                                                            vendor.account_status ===
                                                                            'Pending Activation'
                                                                        "
                                                                        class="badge text-bg-primary processing"
                                                                    >
                                                                        {{
                                                                            vendor.account_status
                                                                        }}
                                                                    </span>

                                                                    <span
                                                                        *ngIf="
                                                                            vendor.account_status ===
                                                                            'Account Activated'
                                                                        "
                                                                        class="badge text-bg-primary paid"
                                                                    >
                                                                        {{
                                                                            vendor.account_status
                                                                        }}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        *ngIf="
                                                                            vendor.email_delivery_status ===
                                                                            'Email Bounced'
                                                                        "
                                                                        class="badge text-bg-primary processing"
                                                                    >
                                                                        {{
                                                                            vendor.email_delivery_status
                                                                        }}
                                                                    </span>

                                                                    <span
                                                                        *ngIf="
                                                                            vendor.email_delivery_status ===
                                                                            'Email Sent to Vendor'
                                                                        "
                                                                        class="badge text-bg-primary paid"
                                                                    >
                                                                        {{
                                                                            vendor.email_delivery_status
                                                                        }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colspan="9">
                                                                    <button
                                                                        [disabled]="
                                                                            !isSelected
                                                                        "
                                                                        class="btn btn-invoice float-start"
                                                                        (click)="
                                                                            deactiveAccount()
                                                                        "
                                                                    >
                                                                        Deactive
                                                                        Portal
                                                                        Account
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </ng-container>
                                                <ng-template #noResults>
                                                    <p class="text-center">
                                                        No Results Found for "{{
                                                            searchTerm
                                                        }}"
                                                    </p>
                                                </ng-template>
                                            </ng-container>

                                            <div class="table-footer py-3">
                                                <div class="row">
                                                    <div class="col-sm-5">
                                                        <label
                                                            class="d-inline-flex align-items-center mb-3"
                                                        >
                                                            Show
                                                            <select
                                                                id="demo-show-entries"
                                                                class="form-select form-select-sm mx-1"
                                                                [(ngModel)]="
                                                                    pageSize
                                                                "
                                                                (ngModelChange)="
                                                                    refreshPos()
                                                                "
                                                            >
                                                                <option
                                                                    [ngValue]="
                                                                        10
                                                                    "
                                                                >
                                                                    10
                                                                </option>
                                                                <option
                                                                    [ngValue]="
                                                                        25
                                                                    "
                                                                >
                                                                    25
                                                                </option>
                                                                <option
                                                                    [ngValue]="
                                                                        50
                                                                    "
                                                                >
                                                                    50
                                                                </option>
                                                                <option
                                                                    [ngValue]="
                                                                        100
                                                                    "
                                                                >
                                                                    100
                                                                </option>
                                                            </select>
                                                            entries
                                                        </label>
                                                    </div>
                                                    <div class="col-sm-7">
                                                        <div class="text-end">
                                                            <!-- Showing 1-5 of 15 entries -->
                                                            <ngb-pagination
                                                                class="justify-content: flex-end !important;"
                                                                [collectionSize]="
                                                                    collectionSize
                                                                "
                                                                [(page)]="page"
                                                                [pageSize]="
                                                                    pageSize
                                                                "
                                                                (pageChange)="
                                                                    refreshPos()
                                                                "
                                                            >
                                                            </ngb-pagination>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
